"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createQueryFilter = void 0;
const fuzzysearch_1 = __importDefault(require("fuzzysearch"));
const lodash_1 = require("lodash");
function createQueryFilter(sanitizedQuery) {
    const filterByQuery = (item) => fuzzysearch_1.default(sanitizedQuery, lodash_1.toLower(item.label)) ||
        fuzzysearch_1.default(sanitizedQuery, lodash_1.toLower(item.value)) ||
        fuzzysearch_1.default(sanitizedQuery, lodash_1.toLower(item.sample));
    return filterByQuery;
}
exports.createQueryFilter = createQueryFilter;
